import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { getTopBarStyleObject } from './topBar.style';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { useStyles } from '../../../common/hooks/useStyles';
import { splitViewSelector } from '../../../common/store/selectors/splitView.selector';
import { css } from '../../../common/styles/styles.utils';
import { getTopBarId } from '../htmlElements/htmlElementsIdGetter';
import { adsDataSelector } from '../../../common/store/selectors/adsData.selector';
import { LogoAndTitle } from './logoAndTitle/logoAndTitle';
import { anchorOptionsSelector } from '../../../common/store/selectors/anchorOptions.selector';
import { isEmpty } from '../../../common/utils/utils';
import { anchorDataSelector } from '../../../common/store/selectors/anchorData.selector';
import { recirculationVideoDataSelector } from '../../../common/store/selectors/recirculationVideoData.selector';
import { videoDataSelector } from '../../../common/store/selectors/videoData.selector';

interface TopBarComponentVariablesProps {
  clickToPlayMode: boolean;
  ctaButtonWidth: number;
  showCTA: boolean;
}

export const TopBar: FunctionComponent<TopBarComponentVariablesProps> = props => {
  const { clickToPlayMode, ctaButtonWidth, showCTA } = props;

  const playerSize = useSelector(playerDataSelector.playerSize);
  const splitViewRatio = useSelector(splitViewSelector.splitViewRatio);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const showControls = useSelector(playerDataSelector.showControls);
  const canClose = useSelector(anchorOptionsSelector.canClose);
  const anchorStatus = useSelector(anchorDataSelector.anchorStatus);
  const numberOfScenes = useSelector(recirculationVideoDataSelector.numberOfScenes);
  const title = useSelector(videoDataSelector.title);

  const isAnchored = anchorStatus === 'active';
  const isTitle = !isEmpty(title);
  const showCloseBar = isAnchored && canClose && isEmpty(splitViewRatio);
  const showAdControls = isVastAd && adBreak;
  const isTopBarVisible = !clickToPlayMode && showControls;
  const isRecirculationVideo = numberOfScenes !== 0;
  const showStoriesSeekBars = isRecirculationVideo && !showAdControls;

  const styles = useStyles(getTopBarStyleObject, [isTopBarVisible, isTitle, playerSize, showAdControls, splitViewRatio, showCloseBar, showStoriesSeekBars, showCTA]);
  const { topBarContainerStyle } = styles;

  return (
    <div
      style={css(topBarContainerStyle)}
      id={getTopBarId(playerUniqueId)}
      onClick={(e): void => e.stopPropagation()}
    >
      <LogoAndTitle ctaButtonWidth={ctaButtonWidth} />
    </div>
  );
};
